define((require, exports, module) => {
    'use strict';

    const UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     */
    function FileTooLargeError() {
        // eslint-disable-next-line prefer-rest-params
        UploadError.apply(this, arguments);
    }

    FileTooLargeError.prototype = Object.assign(
        Object.create(UploadError.prototype),
        {
            constructor: FileTooLargeError,
            className: 'FileTooLargeError',
            radarName: 'error_{SOURCE}_file-too-large',
            message: 'Слишком большой файл.',
        },
    );

    module.exports = FileTooLargeError;
});
